import { CallDropped, LocationMark, Mail } from '@/components/icons'

const LoadingCard = () => {
  return (
    <div className="grid min-h-[128px] grid-cols-1 gap-5 rounded-[12px] border border-secondary-light bg-white p-6 font-medium sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      <span className="flex flex-[1.1_1.1_0%] flex-row items-center gap-4 font-semibold text-secondary-darkest">
        <span className="animate-pulse overflow-hidden rounded-full border border-secondary-light bg-secondary-lightest p-[40px]" />
        <span className="flex w-full flex-col gap-3">
          <span className="h-[10px] w-full animate-pulse rounded-md bg-secondary-light" />
          <span className="h-[10px] w-1/2 animate-pulse rounded-md bg-secondary-light" />
        </span>
      </span>
      <span className="flex flex-1 flex-row items-center gap-2 text-secondary-darkest">
        <span className="rounded-full border border-secondary-light p-3 text-primary">
          <LocationMark />
        </span>
        <span className="h-[10px] w-full animate-pulse rounded-md bg-secondary-light" />
      </span>
      <span className="flex flex-[0.7_0.7_0%] flex-row items-center gap-2">
        <span className="rounded-full border border-secondary-light p-3 text-primary">
          <CallDropped />
        </span>
        <span className="h-[10px] w-full animate-pulse rounded-md bg-secondary-light" />
      </span>
      <span className="flex flex-1 flex-row items-center gap-2">
        <span className="rounded-full border border-secondary-light p-3 text-primary">
          <Mail />
        </span>
        <span className="h-[10px] w-full animate-pulse rounded-md bg-secondary-light" />
      </span>
    </div>
  )
}

export default LoadingCard
